import { gql } from '@apollo/client'

export const ADD_VACCINATION_RECORD = gql`
  mutation AddVaccinationRecord($inputData: AddVaccinationRecordInput!) {
    addVaccinationRecord(inputData: $inputData) {
      id
    }
  }
`
